import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { onMounted, ref } from "vue"
import { useHead } from "@unhead/vue"
import Navbar from "@/components/navigation/Navbar.vue"
import Footer from "@/components/navigation/Footer.vue"
import CurtainAnimation from "@/components/general/CurtainAnimation.vue"
import QuickContactWidget from "@/components/general/QuickContactWidget.vue"
import router from "./router"
import { setMetaData } from "@/utils/functions"
import { useApolloClient } from '@vue/apollo-composable'
import 'animate.css'


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const { resolveClient } = useApolloClient()
const ApolloClient = resolveClient()
const isCurtainClosed = ref(false);

function onCurtainClosed() {
  isCurtainClosed.value = true;
}

useHead({
  titleTemplate: (titleChunk) => {
    return titleFormat(titleChunk);
  },
  meta: [
    { name: "description", content: "We're Nologo Studios. We believe in developing and implementing clear strategies for how digital can grow your business and achieve your goals." }
  ],
  title: null,
})

onMounted(() => {
  getMetaData(router.currentRoute.value.path)
})

router.afterEach((to, from) => {
  if (from.path !== to.path) {
    if (!to.path.startsWith('/services/')) {
      getMetaData(to.path)
    }
  }
})

function getMetaData(path: string) {
  setMetaData(path == "/" ? "home" : path, ApolloClient)
}

function titleFormat(titleChunk: any) {
  const isServiceRoute = router.currentRoute.value.path.startsWith('/services/');

  if (isServiceRoute && !titleChunk) {
    return null;
  }

  if (titleChunk) {
    return titleChunk + " | Nologo Studios";
  }

  return "Nologo Studios";
}

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CurtainAnimation, { onCurtainClosed: onCurtainClosed }),
    _createElementVNode("div", {
      class: _normalizeClass({ 'content-hidden': !isCurtainClosed.value })
    }, [
      (_ctx.$route.name !== 'PageNotFound')
        ? (_openBlock(), _createBlock(Navbar, { key: 0 }))
        : _createCommentVNode("", true),
      _createElementVNode("main", null, [
        _createVNode(_component_router_view)
      ]),
      (_ctx.$route.name !== 'PageNotFound')
        ? (_openBlock(), _createBlock(Footer, { key: 1 }))
        : _createCommentVNode("", true),
      (_ctx.$route.name !== 'PageNotFound')
        ? (_openBlock(), _createBlock(QuickContactWidget, { key: 2 }))
        : _createCommentVNode("", true)
    ], 2)
  ], 64))
}
}

})